import React from "react";
import { useTheme } from "../../../context/ThemeContext";

const DeleteConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  strategyName,
  isDeleting = false,
}) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-p400 p-6 rounded-xl text-center max-w-64">
        {/* Header */}
        <div className="flex flex-col items-center">
          <div className="text-4xl">🤔</div>
          <h3 className="font-medium text-[14px] mt-3 text-n800">
            Delete Strategy
          </h3>
          <p className="text-[12px] font-medium text-n500 mt-1 max-w-52">
            Are you sure you want to delete{" "}
            <span className="text-p300 text-sm">"{strategyName}" </span>
            strategy?
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-3 mt-6">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="border border-n200 px-4 py-2 rounded-lg">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-swipe-button text-p400 px-4 py-2 rounded-lg w-36 text-sm font-semibold text-[12px] flex items-center justify-center gap-2">
            {isDeleting ? (
              <>
                <div className="w-4 h-4 border-2 border-p400 border-t-transparent rounded-full animate-spin"></div>
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationDialog;
